//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { PojoMap } from 'pojo-maps';
import { createSelector } from 'reselect';

import { PostDetailsFormFieldErrorText } from '@instagram-account/post-details/postDetailsUIConstants';
import { IInstagramPostDetailsStoryClip } from '@instagram-account/redux/story-group-post-details/instagramStoryGroupPostDetailsModel';
import { ICuralateStore } from '@models/AppState';
import Cuid from '@models/Cuid';
import { IMlsMediaItem } from '@models/IMlsMediaItem';
import { getScheduleMediaMap } from '@redux/schedule-media/getScheduleMediaMap';

export interface IMaterializedStoryClip {
  clip: IInstagramPostDetailsStoryClip;
  mediaItem?: IMlsMediaItem;
}

const getCurrentStoryClipsImpl = (
  storyClips: IInstagramPostDetailsStoryClip[],
  scheduleMedia: PojoMap<Cuid, IMlsMediaItem>,
): IMaterializedStoryClip[] => {
  return storyClips.map((clip) => {
    return {
      clip,
      mediaItem: clip.cuid && PojoMap.get(scheduleMedia, clip.cuid),
    };
  });
};

export const getCurrentStoryClips = createSelector(
  (state: ICuralateStore) =>
    state.instagram.storyGroupPostDetails.currentStoryGroupPostDetails
      .storyClips,
  getScheduleMediaMap,
  getCurrentStoryClipsImpl,
);

export const getStoryClipsValidationMessages = createSelector(
  getCurrentStoryClips,
  (storyClips) => {
    const validationErrors = storyClips.map((c) => c.clip.validationErrors);
    if (validationErrors.some((e) => e.NoMediaStoryClip)) {
      return PostDetailsFormFieldErrorText.NoMediaStoryClip;
    } else if (validationErrors.some((e) => e.Gif)) {
      return PostDetailsFormFieldErrorText.MediaIsGif;
    } else if (validationErrors.some((e) => e.InvalidStoryVideo)) {
      return PostDetailsFormFieldErrorText.InvalidStoryVideoMessage;
    } else if (validationErrors.some((e) => e.InvalidIgImageSize)) {
      return PostDetailsFormFieldErrorText.InvalidIgImageSize;
    }
    return undefined;
  },
);
